import store from '../../../store'

export default [
	{
		path: '/app/welcome',
		name: 'welcome',
		component: () => import('../../../views/dashboard/customer/WelcomeComponent.vue'),
		meta: {
			allowedUsers: ['customer'],
		},
	},
	{
		path: '/app/dashboard',
		component: () => import('../../../views/dashboard/DashboardComponent.vue'),
		children: [
			{
				path: '/app/dashboard',
				name: 'dashboard',
				component: () => (store.state.user.type === 'customer' ? import('../../../views/dashboard/customer/DashboardComponent.vue') : import('../../../views/dashboard/back-office/DashboardComponent.vue')),
				meta: {
					allowedUsers: ['customer', 'back-office'],
				},
			},
			{
				path: '/app/documents',
				name: 'documents',
				component: () => (store.state.user.type === 'customer' ? import('../../../views/dashboard/customer/DocumentsComponent.vue') : import('../../../views/dashboard/back-office/DocumentsComponent.vue')),
				meta: {
					allowedUsers: ['customer', 'back-office'],
				},
			},
			{
				path: '/app/messages',
				name: 'messages',
				redirect: {
					name: 'messages.inbox',
				},
				component: () => (store.state.user.type === 'customer' ? import('../../../views/dashboard/customer/MessagesComponent.vue') : import('../../../views/dashboard/back-office/MessagesComponent.vue')),
				children: [
					{
						path: '/app/messages/inbox',
						name: 'messages.inbox',
						component: () => (store.state.user.type === 'customer' ? import('../../../views/dashboard/customer/messages/InboxComponent.vue') : import('../../../views/dashboard/back-office/messages/InboxComponent.vue')),
						meta: {
							allowedUsers: ['customer', 'back-office'],
						},
						children: [
							{
								path: '/app/messages/inbox/:id',
								name: 'messages.inbox.view',
								component: () => (store.state.user.type === 'customer' ? import('../../../views/dashboard/customer/messages/ViewMessageComponent.vue') : import('../../../views/dashboard/back-office/messages/ViewMessageComponent.vue')),
								meta: {
									allowedUsers: ['customer', 'back-office'],
								},
							},
						],
					},
					{
						path: '/app/messages/sent',
						name: 'messages.sent',
						component: () => import('../../../views/dashboard/customer/messages/SentComponent.vue'),
						meta: {
							allowedUsers: ['customer'],
						},
						children: [
							{
								path: '/app/messages/sent/:id',
								name: 'messages.sent.view',
								component: () => import('../../../views/dashboard/customer/messages/ViewMessageComponent.vue'),
								meta: {
									allowedUsers: ['customer'],
								},
							},
						],
					},
					{
						path: '/app/messages/new',
						name: 'messages.new',
						component: () => import('../../../views/dashboard/customer/messages/NewMessageComponent.vue'),
						meta: {
							allowedUsers: ['customer'],
						},
					},
					{
						path: '/app/messages/push-notifications',
						name: 'messages.push-notifications',
						component: () => import('../../../views/dashboard/back-office/PushNotificationsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/assets',
				redirect: {
					name: 'assets.manage',
				},
				component: () => import('../../../views/dashboard/back-office/AssetsComponent.vue'),
				children: [
					{
						path: '/app/assets',
						name: 'assets.manage',
						component: () => import('../../../views/dashboard/back-office/assets/ManageAssetsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/assets/new',
						name: 'assets.new',
						component: () => import('../../../views/dashboard/back-office/assets/NewAssetComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/assets/:isin',
						name: 'assets.show',
						component: () => import('../../../views/dashboard/back-office/assets/ViewAssetComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/fixed-income',
				redirect: {
					name: 'fixed-income.manage',
				},
				component: () => import('../../../views/dashboard/back-office/FixedIncomeComponent.vue'),
				children: [
					{
						path: '/app/fixed-income',
						name: 'fixed-income.manage',
						component: () => import('../../../views/dashboard/back-office/fixed-income/ManageFixedIncomeComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/fixed-income/new',
						name: 'fixed-income.new',
						component: () => import('../../../views/dashboard/back-office/fixed-income/NewFixedIncomeComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/fixed-income/upload',
						name: 'fixed-income.upload',
						component: () => import('../../../views/dashboard/back-office/fixed-income/UploadFixedIncomeComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/fixed-income/:isin',
						name: 'fixed-income.show',
						component: () => import('../../../views/dashboard/back-office/fixed-income/ViewFixedIncomeComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/holdings',
				redirect: {
					name: 'holdings.manage',
				},
				component: () => import('../../../views/dashboard/back-office/HoldingsComponent.vue'),
				children: [
					{
						path: '/app/holdings',
						name: 'holdings.manage',
						component: () => import('../../../views/dashboard/back-office/holdings/ManageHoldingsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/holdings/new',
						name: 'holdings.new',
						component: () => import('../../../views/dashboard/back-office/holdings/NewHoldingComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/holdings/upload',
						name: 'holdings.upload',
						component: () => import('../../../views/dashboard/back-office/holdings/UploadHoldingsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/holdings/:id',
						name: 'holdings.show',
						component: () => import('../../../views/dashboard/back-office/holdings/ViewHoldingComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/fx-rates',
				name: 'fx-rates',
				component: () => import('../../../views/dashboard/back-office/FxRatesComponent.vue'),
				meta: {
					allowedUsers: ['back-office'],
				},
			},
			{
				path: '/app/prices',
				redirect: {
					name: 'prices.manage',
				},
				component: () => import('../../../views/dashboard/back-office/PricesComponent.vue'),
				children: [
					{
						path: '/app/prices',
						name: 'prices.manage',
						component: () => import('../../../views/dashboard/back-office/prices/ManagePricesComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/prices/upload',
						name: 'prices.upload',
						component: () => import('../../../views/dashboard/back-office/prices/UploadPricesComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/prices/attach-file',
						name: 'prices.attach-file',
						component: () => import('../../../views/dashboard/back-office/prices/AttachFileComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/portfolios',
				redirect: {
					name: 'portfolios.manage',
				},
				component: () => import('../../../views/dashboard/back-office/PortfoliosComponent.vue'),
				children: [
					{
						path: '/app/portfolios',
						name: 'portfolios.manage',
						component: () => import('../../../views/dashboard/back-office/portfolios/ManagePortfoliosComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/portfolios/upload',
						name: 'portfolios.upload',
						component: () => import('../../../views/dashboard/back-office/portfolios/UploadPortfoliosComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/portfolios/create/:client?',
						name: 'portfolios.create',
						component: () => import('../../../views/dashboard/back-office/portfolios/CreatePortfolioComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/portfolios/:portfolio',
						name: 'portfolios.show',
						component: () => import('../../../views/dashboard/back-office/portfolios/ViewPortfolioComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/clients',
				redirect: {
					name: 'clients.manage',
				},
				component: () => import('../../../views/dashboard/back-office/ClientsComponent.vue'),
				children: [
					{
						path: '/app/clients',
						name: 'clients.manage',
						component: () => import('../../../views/dashboard/back-office/clients/ManageClientsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					// {
					//     path: "/app/clients/new",
					//     name: "clients.new",
					//     component: () => import("../../../views/dashboard/back-office/clients/NewClientComponent.vue"),
					//     meta: {
					//         allowedUsers: ['back-office']
					//     }
					// },
					{
						path: '/app/clients/upload',
						name: 'clients.upload',
						component: () => import('../../../views/dashboard/back-office/clients/UploadClientsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/clients/manage-subaccounts',
						name: 'clients.manage-subaccounts',
						component: () => import('../../../views/dashboard/back-office/clients/AssignClientSubAccountComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/clients/:id',
						name: 'clients.show',
						component: () => import('../../../views/dashboard/back-office/clients/ViewClientComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/requests',
				name: 'requests',
				redirect: {
					name: 'requests.manage',
				},
				component: () => import('../../../views/dashboard/back-office/RequestsComponent.vue'),
				children: [
					{
						path: '/app/requests',
						name: 'requests.manage',
						component: () => import('../../../views/dashboard/back-office/requests/ManageRequestsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/requests/new',
						name: 'requests.new',
						component: () => import('../../../views/dashboard/back-office/requests/NewRequestComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/requests-withdrawals',
						name: 'requests.withdrawals',
						component: () => import('../../../views/dashboard/back-office/requests/WithdrawalRequestsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/requests/:id',
						name: 'requests.show',
						component: () => import('../../../views/dashboard/back-office/requests/ViewRequestComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/fees',
				redirect: {
					name: 'fees.manage',
				},
				component: () => import('../../../views/dashboard/back-office/FeesComponent.vue'),
				children: [
					{
						path: '/app/fees',
						name: store.state.user.type === 'customer' ? 'fees' : 'fees.manage',
						component: () => (store.state.user.type === 'customer' ? import('../../../views/dashboard/customer/FeesComponent.vue') : import('../../../views/dashboard/back-office/fees/ManageFeesComponent.vue')),
						meta: {
							allowedUsers: ['customer', 'back-office'],
						},
					},
					{
						path: '/app/fees/new',
						name: 'fees.new',
						component: () => import('../../../views/dashboard/back-office/fees/NewFeeComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/fees/upload',
						name: 'fees.upload',
						component: () => import('../../../views/dashboard/back-office/fees/UploadFeesComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/fees/:id',
						name: 'fees.show',
						component: () => import('../../../views/dashboard/back-office/fees/ViewFeeComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/transactions',
				redirect: {
					name: 'transactions.manage',
				},
				component: () => import('../../../views/dashboard/back-office/TransactionsComponent.vue'),
				children: [
					{
						path: '/app/transactions',
						name: 'transactions.manage',
						component: () => import('../../../views/dashboard/back-office/transactions/ManageTransactionsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/transactions/new',
						name: 'transactions.new',
						component: () => import('../../../views/dashboard/back-office/transactions/NewTransactionComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/transactions/upload',
						name: 'transactions.upload',
						component: () => import('../../../views/dashboard/back-office/transactions/UploadTransactionsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/transactions/:id',
						name: 'transactions.show',
						component: () => import('../../../views/dashboard/back-office/transactions/ViewTransactionComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/transactions/redemptions',
						name: 'transactions.check-redemptions',
						component: () => import('../../../views/dashboard/back-office/transactions/CheckRedemptionsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/subscriptions',
				redirect: {
					name: 'subscriptions.manage',
				},
				component: () => import('../../../views/dashboard/back-office/SubscriptionsComponent.vue'),
				children: [
					{
						path: '/app/subscriptions',
						name: 'subscriptions.manage',
						component: () => import('../../../views/dashboard/back-office/subscriptions/ManageSubscriptionsComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/subscriptions/new',
						name: 'subscriptions.new',
						component: () => import('../../../views/dashboard/back-office/subscriptions/CreateSubscriptionComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/subscriptions/upload',
						name: 'subscriptions.upload',
						component: () => import('../../../views/dashboard/back-office/subscriptions/UploadSubscriptionComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/subscriptions/bulk-update',
						name: 'subscriptions.bulk-update',
						component: () => import('../../../views/dashboard/back-office/subscriptions/BulkUpdateSubscriptionComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
					{
						path: '/app/subscriptions/:id',
						name: 'subscriptions.show',
						component: () => import('../../../views/dashboard/back-office/subscriptions/ViewSubscriptionComponent.vue'),
						meta: {
							allowedUsers: ['back-office'],
						},
					},
				],
			},
			{
				path: '/app/configurations',
				name: 'configurations',
				component: () => import('../../../views/dashboard/back-office/ManageConfigurationComponent.vue'),
				meta: {
					allowedUsers: ['back-office'],
				},
			},
			{
				path: '/app/commands',
				name: 'commands',
				component: () => import('../../../views/dashboard/back-office/ManageCommandsComponent.vue'),
				meta: {
					allowedUsers: ['back-office'],
				},
			},
			{
				path: '/app/sub-accounts',
				name: 'account.sub-accounts',
				component: () => import('../../../views/dashboard/customer/settings/SubAccountComponent.vue'),
				meta: {
					allowedUsers: ['customer'],
				},
			},
			{
				path: '/app/approvals',
				redirect: {
					name: 'approvals.manage'
				},
				component: () => import('../../../views/dashboard/customer/ApprovalsComponent.vue'),
				children: [{
						path: '/app/approvals',
						name: 'approvals.manage',
						component: () => import('../../../views/dashboard/customer/approvals/ManageApprovalsComponent.vue'),
						meta: {
							allowedUsers: ['customer']
						}
					},
					{
						path: '/app/approvals/:id',
						name: 'approvals.view',
						component: () => import('../../../views/dashboard/customer/approvals/ViewApprovalComponent.vue'),
						meta: {
							allowedUsers: ['customer']
						}
					}
				]
			},
		],
	},
]
